module.exports = __webpack_public_path__ + "img/9类电池.5dac9227.png";